import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import axios from "axios";
import '../../Style/EditModal.scss';
import "../../Style/TableStyle.scss"
import '../../Style/__searchbar.scss'
import '../../Style/__button.scss'
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { SiHyperledger } from "react-icons/si";
import "jspdf-autotable";
import { MonthlyPurchaseReportHeader } from "./GridHeaders/MonthlySalesReportHeader";
import DataGridComponent from "../../Components/DataGridComponent";
import { errorAlert } from "../../Components/Alerts";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import ExcelFormat from "../../Components/ExcelConverter/ExcelFormat";
import { purchaseColumns, purchaseMappings } from "../../Components/ExcelConverter/FinancialStatement";
import TotalSummaryComponent from "../../Components/TotalSummaryComponent";

export default function MonthlyPurchaseReport() {
    const [data, setData] = useState([]);
    const headers = authHeader();
    const { fiscalYear } = useContext(FiscalYearContext);

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'FinanceStatement/MonthlyPurchaseReport', { headers, params: { fiscalYear: fiscalYear } });
            setData(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const amount0Total = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Vlera0), 0);
    }, [data]);

    const amount8Total = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Vlera8), 0);
    }, [data]);

    const amount18Total = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Vlera18), 0);
    }, [data]);

    const amountTotal = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.TotalPaTVSH), 0);
    }, [data]);

    const rivlersimiTotal = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Rivleresimi), 0);
    }, [data]);

    const vleraPaRivlersimTotal = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.VleraPaRivleresim), 0);
    }, [data]);

    const rows = data.map((item, index) => ({
        id: ++index,
        muaji: item.Muaji,
        trs: (item.Transaksione),
        amount0: (item.Vlera0),
        amount8: (item.Vlera8),
        amount18: (item.Vlera18),
        totalamount: (item.TotalPaTVSH),
        rivleresimi: (item.Rivleresimi),
        vleraparivleresim: (item.VleraPaRivleresim),
    }));


    useEffect(() => {
        fetchData();
    }, [fiscalYear]);

    return (
        <div className="Crud__Container">
            <TitleElements
                icon={SiHyperledger}
                title="Raporti mujor i blerjeve"
            />
            <ElementsParagraph text="Raporti mujor i blerjeve është raport sintetik që bën grumbullimin e blerjeve në secilin muaj të vitit fiskal." />

            <hr></hr>
            <ExcelFormat
                data={data}
                fileName={`Raporti mujor i blerjeve`}
                columns={purchaseColumns}
                columnMappings={purchaseMappings}
                buttonText="XLSX"
            />
            <DataGridComponent columns={MonthlyPurchaseReportHeader} rows={rows} />
            <TotalSummaryComponent
                fields={[
                    { id: 1, label: 'Vlera me 0%', value: amount0Total },
                    { id: 2, label: 'Vlera me 8%', value: amount8Total },
                    { id: 3, label: 'Vlera me 18%', value: amount18Total },
                    { id: 4, label: 'Vlera pa TVSH', value: amountTotal },
                    { id: 5, label: 'Rivlersimi', value: rivlersimiTotal },
                    { id: 6, label: 'Vlera pa rivlersim', value: vleraPaRivlersimTotal },
                ]}
            />
        </div>
    )
}